import { Box, Tooltip } from "@chakra-ui/react";
import CDS from "design-system";
import { shortRelative, dateToFormalLongStringWithTimeAndZone } from "helpers/time";

interface LastUsedProps {
  lastUsedAt: string | null;
}

export default function LastUsed({ lastUsedAt }: LastUsedProps) {
  if (!lastUsedAt) {
    return (
      <CDS.Text12 as="span" fontStyle="italic" color="gray.400" cursor="default">
        Not yet assigned
      </CDS.Text12>
    );
  }

  const parsed = new Date(lastUsedAt);
  return (
    <Tooltip label={dateToFormalLongStringWithTimeAndZone(parsed)} placement="top" hasArrow>
      <Box as="span" cursor="default">
        <CDS.Text12 as="span" color="gray.500">
          {shortRelative(lastUsedAt)}
        </CDS.Text12>
      </Box>
    </Tooltip>
  );
}
